import { Systems } from '@moonwave99/fretboard.js';

const BOX_CONFIGS = {
  pentatonic: {
    boxes: ['1', '2', '3', '4', '5', '1\''],
    system: Systems.pentatonic,
    getBoxValue: (box) => {
      const normalized = box === '1\'' ? '1' : box;
      const boxes = ['1', '2', '3', '4', '5', '1\''];
      return boxes.indexOf(normalized);
    },
  },
  CAGED: {
    boxes: ['C', 'A', 'G', 'E', 'D'],
    system: Systems.CAGED,
    getBoxValue: (box) => ['C', 'A', 'G', 'E', 'D'].indexOf(box),
  },
  TNPS: {
    boxes: [1, 2, 3, 4, 5, 6, 7],
    system: Systems.TNPS,
    getBoxValue: (box) => {
      const number = Number.parseInt(box, 10);
      const boxes = [1, 2, 3, 4, 5, 6, 7];
      return boxes.indexOf(number);
    },
  },
};

export function getBoxConfig(mode, system) {
  const isPentatonic = mode.includes('pentatonic');

  if (isPentatonic) {
    return BOX_CONFIGS.pentatonic;
  }

  return BOX_CONFIGS[system] || BOX_CONFIGS.CAGED;
}

export function createCurrentBox(mode, system, boxValue) {
  const config = getBoxConfig(mode, system);
  const normalizedBoxValue = boxValue === '1\'' ? '1' : boxValue;
  const boxIndex = config.getBoxValue(normalizedBoxValue);

  if (boxIndex === -1) {
    console.warn(`Invalid box value: ${boxValue} for system: ${system}`);
    return null;
  }

  return {
    system: config.system,
    box: system === 'pentatonic' ? Number.parseInt(normalizedBoxValue) : config.boxes[boxIndex],
  };
}

export function getValidBoxes(mode, system) {
  const config = getBoxConfig(mode, system);
  return config.boxes;
}

export function getDefaultBox(mode, system) {
  const boxes = getValidBoxes(mode, system);
  return boxes[0];
}

// Helper function to determine if a box is valid for the current mode and system
export function isValidBox(mode, system, boxValue) {
  const validBoxes = getValidBoxes(mode, system);
  return validBoxes.map(String).includes(boxValue);
}
